export enum ModalTypes {
  AccountIdentifyModal = 'AccountIdentifyModal',
  AccountOrderDetailsModal = 'AccountOrderDetailsModal',
  AlternativeChoiceModal = 'AlternativeChoiceModal',
  BasketDeleteItemModal = 'BasketDeleteItemModal',
  BasketGuestOrderModal = 'basketGuestOrderModal',
  BrandsModal = 'BrandsModal',
  BusinessPDPModalForm = 'BusinessPDPModalForm',
  ChangePasswordModal = 'ChangePasswordModal',
  CountOfProductsModal = 'countOfProductsModal',
  DeleteAccountModal = 'DeleteAccountModal',
  DeleteReceiverModal = 'DeleteReceiverModal',
  DeliveryDateAndTimeModal = 'DeliveryDateAndTimeModal',
  DeliveryReceiverModal = 'deliveryReceiverModal',
  EditReceiverConfirmationModal = 'EditReceiverConfirmationModal',
  ErrorModal = 'ErrorModal',
  FilterModal = 'FilterModal',
  GiftPackingPreviewModal = 'GiftPackingPreviewModal',
  LoginModal = 'LoginModal',
  PackageItemPreviewModal = 'PackageItemPreviewModal',
  ProductDeliveryOverviewModal = 'ProductDeliveryOverviewModal',
  ProductDeliveryReceiversModal = 'ProductDeliveryReceiversModal',
  ProductOrderOverviewModal = 'productOrderOverviewModal',
  RedeemAddExtraCardModal = 'RedeemAddExtraCardModal',
  RedeemBasketModal = 'RedeemBasketModal',
  RedeemCardNumberModal = 'RedeemCardNumberModal',
  RedeemDoublerModal = 'RedeemDoublerModal',
  RedeemGiftCardModal = 'RedeemGiftCardModal',
  RedeemGuestOrderFormModal = 'RedeemGuestOrderFormModal',
  RedeemNiceToKnowInformationModal = 'RedeemNiceToKnowInformationModal',
  RedeemResetModal = 'RedeemResetModal',
  RedeemShopIframeModal = 'RedeemShopIframeModal',
  RedeemShopMoreInformationModal = 'RedeemShopMoreInformationModal',
  ReorderProductDetailsModal = 'ReorderProductDetailsModal',
  ResetReceiverConfirmationModal = 'ResetReceiverConfirmationModal',
  StoreSwitcherModal = 'StoreSwitcherModal',
  TestimonialsMobileModal = 'TestimonialsMobileModal',
  WrapperOverlayModal = 'WrapperOverlayModal',
}

export type OnModalOpen = (closePrevModals?: boolean) => void;
